import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { NotesStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof NotesStateValues>[] = [
  {
    name: 'wouldYouLikeToProvideAdditionalInformationThatYouFeelWouldBeRelevantThatWasNotCoveredByOtherPartsOfTheQuestionnaireinTextForm',
    label:
      'Would you like to provide additional information that you feel would be relevant that was not covered by other parts of the Questionnaire (in text form)?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'notes',
        label: 'Notes',
        type: 'textarea',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  notes: Yup.string()
    .nullable()
    .when(
      'wouldYouLikeToProvideAdditionalInformationThatYouFeelWouldBeRelevantThatWasNotCoveredByOtherPartsOfTheQuestionnaireinTextForm',
      {
        is: 'yes',
        then: Yup.string().nullable().required('required'),
      },
    ),
});
